var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.00001H3.41401L6.70701 1.70701C7.09801 1.31601 7.09801 0.684006 6.70701 0.293006C6.31601 -0.0979941 5.68401 -0.0979941 5.29301 0.293006L0.293006 5.29301C-0.0979941 5.68401 -0.0979941 6.31601 0.293006 6.70701L5.29301 11.707C5.48801 11.902 5.74401 12 6.00001 12C6.25601 12 6.51201 11.902 6.70701 11.707C7.09801 11.316 7.09801 10.684 6.70701 10.293L3.41401 7.00001H15C15.553 7.00001 16 6.55201 16 6.00001C16 5.44801 15.553 5.00001 15 5.00001Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ac4e80c301a2d442a3a332c42be4e3fc.svg";
export { ForwardRef as ReactComponent };